import { useIntl } from 'react-intl';

import { useSelector } from '../../context/hooks';
import {
	getNumberFormatLocale,
	selectMeter,
	selectIncludedAllowance,
} from '../../context/selectors';
import { useCollectionDescriptions } from '../product-descriptions';
import { METER_LABEL_MESSAGES, collectionAllowanceMessage, formatNumber } from '../strings';

import { EDITIONS } from './common/edition-options';
import { ProductCard } from './common/product-card';
import { useProductCardData } from './common/use-product-card-data';

export const ServiceCollectionProductCard = () => {
	const { shortDescription, list } = useCollectionDescriptions().serviceCollection;
	const meter = useSelector(selectMeter);
	const allowance = useSelector(selectIncludedAllowance);
	const intl = useIntl();
	// Was hardcoded to `toLocaleString('en-US')`, which grouped digits with
	// US separators regardless of the user's locale.
	const locale = useSelector(getNumberFormatLocale);
	const additionalBenefit = intl.formatMessage(collectionAllowanceMessage, {
		allowance: formatNumber(allowance, locale),
		meterLabel: intl.formatMessage(METER_LABEL_MESSAGES[meter]),
	});
	return (
		<ProductCard
			{...useProductCardData('serviceCollection')}
			title="Service Collection"
			description={shortDescription}
			list={list}
			unitType="agent"
			editions={EDITIONS}
			additionalBenefit={additionalBenefit}
		/>
	);
};
